<script>
import _ from "lodash";
import Qs from "qs";
import Lockr from "lockr";
import BaseFilters from "../base-filters.vue";
import Api from "@/store/jsonapi";
import { mapState } from "vuex";

export default {
  extends: BaseFilters,
  data: function () {
    let filters = [
      {
        name: this.$i18n.t("all"),
        conditions: [],
        built_in: true,
      },
      {
        name: this.$i18n.t("unknown"),
        built_in: true,
        conditions: [
          {
            attr: "onboarding_status",
            op: { val: "=", label: this.$t("equal") },
            value: {
              val: "unknown",
              label: this.$t("unknown"),
            },
          },
        ],
      },
    ];

    return {
      group: "backend-customers",
      carriers: [],
      order_channels: [],
      plans: [],
      tags: [],
      users: [],
      organizations: [],
      built_in_filters: filters,
    };
  },
  computed: {
    attributes() {
      let attrs = [
        {
          name: "service_status",
          type: "Array",
          value: [
            {
              val: "running",
              label: this.$t("running"),
            },
            {
              val: "test",
              label: this.$t("test"),
            },
            {
              val: "disabled",
              label: this.$t("disabled"),
            },
          ],
        },

        {
          name: "onboarding_status",
          type: "Array",
          value: [
            {
              val: "onboarding",
              label: this.$t("onboarding"),
            },
            {
              val: "migrating",
              label: this.$t("migrating"),
            },
            {
              val: "demo",
              label: this.$t("demo"),
            },
            {
              val: "unknown",
              label: this.$t("unknown"),
            },
            {
              val: "onboarded",
              label: this.$t("onboarded"),
            },
            {
              val: "migrated",
              label: this.$t("migrated"),
            },
            {
              val: "drop_point_only",
              label: this.$t("drop_point_only"),
            },
            {
              val: "external",
              label: this.$t("external"),
            },
            {
              val: "cancelled",
              label: this.$t("cancelled"),
            },
          ],
        },
        {
          name: "carrier",
          type: "Array",
          value: this.carriers,
        },
        {
          name: "onboarding_agent",
          type: "Array",
          value: [{ val: null, label: this.$i18n.t("missing") }].concat(
            this.users
          ),
        },
        {
          name: "sales_agent",
          type: "Array",
          value: [{ val: null, label: this.$i18n.t("missing") }].concat(
            this.users
          ),
        },
        {
          name: "customer_success_agent",
          type: "Array",
          value: [{ val: null, label: this.$i18n.t("missing") }].concat(
            this.users
          ),
        },
        {
          name: "order_channel",
          type: "Array",
          value: this.order_channels,
        },
        {
          name: "plan",
          type: "Array",
          value: this.plans,
        },
        {
          name: "tag",
          type: "Array",
          value: this.tags,
        },
      ];

      return attrs;
    },
  },
  methods: {
    after_mount() {
      Api.findAllPages("tags").then(({ data }) => {
        this.tags = _(data)
          .map((e) => ({ val: e.id, label: e.name }))
          .value();
      });

      if (this.can("read_order_channel_types")) {
        Api.findAllPages("order_channel_types", {
          sort: "name",
          fields: { order_channel_types: "name,id" },
        }).then(({ data }) => {
          this.order_channels = _(data)
            .map((e) => ({ val: e.id, label: e.name }))
            .value();
        });
      }

      if (this.can("read_carrier_types")) {
        Api.findAllPages("carrier_types", {
          sort: "name",
          fields: { carrier_types: "name,id" },
        }).then(({ data }) => {
          this.carriers = _(data)
            .map((e) => ({ val: e.id, label: e.name }))
            .value();
        });
      }

      if (this.can("read_plans")) {
        Api.findAllPages("plans", {
          sort: "name",
          fields: { plans: "name,id" },
        }).then(({ data }) => {
          this.plans = _(data)
            .map((e) => ({ val: e.id, label: e.name }))
            .value();
        });
      }

      if (this.can("read_organizations")) {
        Api.findAllPages("organizations").then(({ data }) => {
          this.organizations = _(data)
            .map((o) => ({ val: o.id, label: o.name }))
            .value();
        });
      }

      if (this.can("read_staffs")) {
        Api.findAllPages("staffs", {
          sort: "first_name",
          fields: { staffs: "first_name,last_name,id" },
        }).then(({ data }) => {
          this.users = _(data)
            .map((e) => ({
              val: e.id,
              label: e.first_name + " " + e.last_name,
            }))
            .value();
        });
      }
    },
  },
};
</script>
